export default {
    "Core Team": [
        [
            {
                "name": "Ranjit Tanneru",
                "designation": "Captain",
                "photo": "Ranjit Tanneru.jpg",
                "linkedin": "https://www.linkedin.com/in/ranjit-tanneru-47381b267",
                "email": "ranjittanneru2005@gmail.com"
            },
            {
                "name": "Ashmit R Sambrani",
                "designation": "Vice Captain",
                "photo": "Ashmit R Sambrani.jpeg",
                "linkedin": "https://www.linkedin.com/in/ashmitsambrani",
                "email": "ashmitrsambrani.231ec109@nitk.edu.in"
            },
            {
                "name": "Nisha Shetty",
                "designation": "Vice Captain",
                "photo": "Nisha Shetty.png",
                "linkedin": "https://www.linkedin.com/in/nisha-shetty06",
                "email": "nishashetty.231ee237@nitk.edu.in"
            },
            {
                "name": "Shamanth P V",
                "designation": "Honorary Core",
                "photo": "Shamanth P V.jpeg",
                "linkedin": "https://www.linkedin.com/in/shamanth-pv-263145262/",
                "email": "shamanth.231ec255@nitk.edu.in"
            }
        ],
        [
            {
                "name": "Madhur Shivanna",
                "designation": "Honorary Core",
                "photo": "Madhur Shivanna.jpg",
                "linkedin": "https://www.linkedin.com/in/madhur-shivanna-7b3042308/",
                "email": "madhurshivanna.231ee131@nitk.edu.in"
            },
            {
                "name": "Dheemanth J",
                "designation": "Electronics & Programming Lead",
                "photo": "Dheemanth J.jpeg",
                "linkedin": "https://www.linkedin.com/in/dheemanth-j-9967462a1",
                "email": "dheemanthj.231ec215@nitk.edu.in"
            },
            {
                "name": "Rohit L",
                "designation": "Electronics & Programming Lead",
                "photo": "Rohit L.jpeg",
                "linkedin": "https://www.linkedin.com/in/rohit-l-731819290",
                "email": "rohitlalu.231ec248@nitk.edu.in"
            },
            {
                "name": "Lianna Mascarenhas",
                "designation": "Mechanical Subsystem Lead",
                "photo": "Lianna Mascarenhas.jpeg",
                "linkedin": "https://www.linkedin.com/in/liannamascarenhas",
                "email": "lianna.231me325@nitk.edu.in"
            }
        ],
        [
            {
                "name": "Kavin Narayan",
                "designation": "Mechanical Subsystem Lead",
                "photo": "Kavin Narayan.jpeg",
                "linkedin": "http://www.linkedin.com/in/kavin-narayan",
                "email": "kavinnarayan.231mt021@nitk.edu.in"
            },
            {
                "name": "Adarsh Bellamane",
                "designation": "Web Lead",
                "photo": "Adarsh.jpeg",
                "linkedin": "https://www.linkedin.com/in/adarsh-bellamane-aa0874331",
                "email": "adarsh.241it004@nitk.edu.in"
            },
            {
                "name": "A. Karthika",
                "designation": "Treasurer",
                "photo": "A. Karthika.jpg",
                "linkedin": "https://www.linkedin.com/in/a-karthika-479583331?utm_source=share_via&utm_content=profile&utm_medium=member_android",
                "email": "akarthika.241me201@nitk.edu.in"
            },
            {
                "name": "Rohini V",
                "designation": "Treasurer",
                "photo": "Rohini V.jpg",
                "linkedin": "https://www.linkedin.com",
                "email": "rohinivn123@gmail.com"
            }
        ],
        [
            {
                "name": "Aniruddh Yelluri",
                "designation": "Electronics and Programming Secretary",
                "photo": "Aniruddh Yelluri.jpg",
                "linkedin": "https://www.linkedin.com/in/aniruddh-yelluri",
                "email": "aniruddhyelluri.241me311@nitk.edu.in"
            },
            {
                "name": "Samip Sorathia",
                "designation": "Electronics and Programming Secretary",
                "photo": "Samip.jpg",
                "linkedin": "https://www.linkedin.com/in/samipsorathia",
                "email": "samipsorathia.241ec248@nitk.edu.in"
            },
            {
                "name": "P Yaagh Aiyappa",
                "designation": "Mechanical Secretary",
                "photo": "P Yaagh Aiyappa.webp",
                "linkedin": "https://www.linkedin.com/in/yaaghaiyappa?utm_source=share_via&utm_content=profile&utm_medium=member_android",
                "email": "yaaghaiyappa.241me240@nitk.edu.in"
            },
            {
                "name": "Kshihtij Praveen Narayanan",
                "designation": "Mechanical Secretary",
                "photo": "Kshitij.jpg",
                "linkedin": "https://www.linkedin.com/in/kshihtij-praveen-61a532330/",
                "email": "kshihtijpraveennarayanan.241me331@nitk.edu.in"
            }
        ],
        [
            {
                "name": "Juhi Arora",
                "designation": "Public Relations Lead",
                "photo": "Juhi Arora.jpeg",
                "linkedin": "https://www.linkedin.com/in/juhi-arora-977309344",
                "email": "juhiarora.241me327@nitk.edu.in"
            },
            {
                "name": "Vibha Ramesh Rao",
                "designation": "Public Relations Lead",
                "photo": "empty photo.jpg",
                "linkedin": "https://www.linkedin.com",
                "email": ""
            },
            {
                "name": "Dhruva S",
                "designation": "Public Relations Lead",
                "photo": "Dhruva S.jpg",
                "linkedin": "https://www.linkedin.com/in/dhruva-s-195046277",
                "email": "dhruva.241me120@nitk.edu.in"
            }
        ]
    ],
    "EC&P Team": [
        {
            "name": "Ashmit R Sambrani",
            "photo": "Ashmit R Sambrani.jpeg",
            "linkedin": "https://www.linkedin.com/in/ashmitsambrani",
            "email": "ashmitrsambrani.231ec109@nitk.edu.in"
        },
        {
            "name": "Ranjit Tanneru",
            "photo": "Ranjit Tanneru.jpg",
            "linkedin": "https://www.linkedin.com/in/ranjit-tanneru-47381b267",
            "email": "ranjittanneru2005@gmail.com"
        },
        {
            "name": "Rohit L",
            "photo": "Rohit L.jpeg",
            "linkedin": "https://www.linkedin.com/in/rohit-l-731819290",
            "email": "rohitlalu.231ec248@nitk.edu.in"
        },
        {
            "name": "Shamanth P V",
            "photo": "Shamanth P V.jpeg",
            "linkedin": "https://www.linkedin.com/in/shamanth-pv-263145262/",
            "email": "shamanth.231ec255@nitk.edu.in"
        },
        {
            "name": "Dheemanth J",
            "photo": "Dheemanth J.jpeg",
            "linkedin": "https://www.linkedin.com/in/dheemanth-j-9967462a1",
            "email": "dheemanthj.231ec215@nitk.edu.in"
        },
        {
            "name": "Adarsh Bellamane",
            "photo": "Adarsh.jpeg",
            "linkedin": "https://www.linkedin.com/in/adarsh-bellamane-aa0874331",
            "email": "adarsh.241it004@nitk.edu.in"
        },
        {
            "name": "Shivani S",
            "photo": "Shivani.jpg",
            "linkedin": "https://www.linkedin.com/in/shivani-s-8a1949324",
            "email": "shivani.241ee155@nitk.edu.in"
        },
        {
            "name": "Malla Anirudh Karthikeya",
            "photo": "Malla.png",
            "linkedin": "https://www.linkedin.com/in/malla-anirudh-69aba5317/",
            "email": "mallaanirudhkarthikeya.241ai023@nitk.edu.in"
        },
        {
            "name": "Aniruddh Yelluri",
            "photo": "Aniruddh Yelluri.jpg",
            "linkedin": "https://www.linkedin.com/in/aniruddh-yelluri",
            "email": "aniruddhyelluri.241me311@nitk.edu.in"
        },
        {
            "name": "Ritesh Suresh Ashtkar",
            "photo": "Ritesh.jpeg",
            "linkedin": "https://www.linkedin.com/in/ritesh-suresh-ashtkar",
            "email": "riteshashtkar.241me145@nitk.edu.in"
        },
        {
            "name": "Samip Sorathia",
            "photo": "Samip.jpg",
            "linkedin": "https://www.linkedin.com/in/samipsorathia",
            "email": "samipsorathia.241ec248@nitk.edu.in"
        },
        {
            "name": "Rohini V",
            "photo": "Rohini V.jpg",
            "linkedin": "https://www.linkedin.com",
            "email": "rohinivn123@gmail.com"
        },
        {
            "name": "Pratham Aditya Mohan",
            "photo": "Pratham.jpg",
            "linkedin": "https://www.linkedin.com/in/pratham-aditya-mohan-76193132b",
            "email": "prathamadityamohan.241ee141@nitk.edu.in"
        },
        {
            "name": "Krishnendu Dutta",
            "photo": "Krishnendu Dutta.jpg",
            "linkedin": "https://www.linkedin.com/in/krishnendu-dutta-536315381?utm_source=share_via&utm_content=profile&utm_medium=member_android",
            "email": "krishnendudutta.251ee131@nitk.edu.in"
        },
        {
            "name": "Sai Sharan SK",
            "photo": "Sai Sharan SK.jpeg",
            "linkedin": "https://www.linkedin.com/in/sksaisharan",
            "email": "sksaisharan.251ec246@nitk.edu.in"
        },
        {
            "name": "Nandana Hiran",
            "photo": "Nandana Hiran.jpg",
            "linkedin": "https://www.linkedin.com/in/nandana-hiran-460696400?utm_source=share_via&utm_content=profile&utm_medium=member_android",
            "email": "nandanahiran.251ec143@nitk.edu.in"
        },
        {
            "name": "Ira Karmarkar",
            "photo": "Ira Karmarkar.jpg",
            "linkedin": "https://www.linkedin.com/in/ira-karmarkar-8b212227a",
            "email": "karmarkarirakedar.251ec128@nitk.edu.in"
        }
    ],
    "Mechanical Team": [
        {
            "name": "Lianna Mascarenhas",
            "photo": "Lianna Mascarenhas.jpeg",
            "linkedin": "https://www.linkedin.com/in/liannamascarenhas",
            "email": "lianna.231me325@nitk.edu.in"
        },
        {
            "name": "Santo Davis",
            "photo": "Santo Davis.jpeg",
            "linkedin": "https://www.linkedin.com/in/santo-davis-aa5286324/",
            "email": "santodavis.231me347@nitk.edu.in"
        },
        {
            "name": "Madhur Shivanna",
            "photo": "Madhur Shivanna.jpg",
            "linkedin": "https://www.linkedin.com/in/madhur-shivanna-7b3042308/",
            "email": "madhurshivanna.231ee131@nitk.edu.in"
        },
        {
            "name": "Kavin Narayan",
            "photo": "Kavin Narayan.jpeg",
            "linkedin": "http://www.linkedin.com/in/kavin-narayan",
            "email": "kavinnarayan.231mt021@nitk.edu.in"
        },
        {
            "name": "Siddharth Mohapatra",
            "photo": "Siddharth.jpg",
            "linkedin": "https://www.linkedin.com/in/siddharth-mohapatra-0599082a7",
            "email": "siddharthmohapatra.241me354@nitk.edu.in"
        },
        {
            "name": "P Yaagh Aiyappa",
            "photo": "P Yaagh Aiyappa.webp",
            "linkedin": "https://www.linkedin.com/in/yaaghaiyappa?utm_source=share_via&utm_content=profile&utm_medium=member_android",
            "email": "yaaghaiyappa.241me240@nitk.edu.in"
        },
        {
            "name": "A. Karthika",
            "photo": "A. Karthika.jpg",
            "linkedin": "https://www.linkedin.com/in/a-karthika-479583331?utm_source=share_via&utm_content=profile&utm_medium=member_android",
            "email": "akarthika.241me201@nitk.edu.in"
        },
        {
            "name": "Kshihtij Praveen Narayanan",
            "photo": "Kshitij.jpg",
            "linkedin": "https://www.linkedin.com/in/kshihtij-praveen-61a532330/",
            "email": "kshihtijpraveennarayanan.241me331@nitk.edu.in"
        },
        {
            "name": "Haarshith Sankar Sasidhr",
            "photo": "Haarshith.jpg",
            "linkedin": "https://www.linkedin.com/in/haarshith-sankar/",
            "email": "haarshithsankarsasidhr.241me125@nitk.edu.in"
        },
        {
            "name": "Tejas Vivek Mallurwar",
            "photo": "Tejas.jpeg",
            "linkedin": "https://github.com/IQOOSOULxTejas",
            "email": "tejasvivekmallurwar.241me358@nitk.edu.in"
        },
        {
            "name": "Juhi Arora",
            "photo": "Juhi Arora.jpeg",
            "linkedin": "https://www.linkedin.com/in/juhi-arora-977309344",
            "email": "juhiarora.241me327@nitk.edu.in"
        },
        {
            "name": "Tanav Chavare",
            "photo": "Tanav Chavare.jpg",
            "linkedin": "https://www.linkedin.com",
            "email": "chavaretanav.241me259@nitk.edu.in"
        },
        {
            "name": "Anuj",
            "photo": "Anuj.jpeg",
            "linkedin": "https://www.linkedin.com/in/anuj-choudhary-4456423a1?utm_source=share_via&utm_content=profile&utm_medium=member_ios",
            "email": "anujchoudhary.251me109@nitk.edu.in"
        },
        {
            "name": "Vihan Srivastava",
            "photo": "Vihan Srivastava.jpg",
            "linkedin": "https://www.linkedin.com/in/vihan-srivastava-a428283b2?utm_source=share_via&utm_content=profile&utm_medium=member_android",
            "email": "vihansri.251me262@nitk.edu.in"
        },
        {
            "name": "Pritam Jana",
            "photo": "Pritam Jana.jpg",
            "linkedin": "https://www.linkedin.com/in/pritamjana?utm_source=share_via&utm_content=profile&utm_medium=member_android",
            "email": "pritamjana.251cv236@nitk.edu.in"
        },
        {
            "name": "Chinmay Raikar",
            "photo": "Chinmay Raikar.png",
            "linkedin": "https://www.linkedin.com/in/chinmay-raikar-173070392?utm_source=share_via&utm_content=profile&utm_medium=member_android",
            "email": "chinmayraghavendraraikar.251ec213@nitk.edu.in"
        }
    ],
    "Support Team": [
        {
            "name": "Ashmit R Sambrani",
            "photo": "Ashmit R Sambrani.jpeg",
            "linkedin": "https://www.linkedin.com/in/ashmitsambrani",
            "email": "ashmitrsambrani.231ec109@nitk.edu.in"
        },
        {
            "name": "Ranjit Tanneru",
            "photo": "Ranjit Tanneru.jpg",
            "linkedin": "https://www.linkedin.com/in/ranjit-tanneru-47381b267",
            "email": "ranjittanneru2005@gmail.com"
        },
        {
            "name": "Nisha Shetty",
            "photo": "Nisha Shetty.png",
            "linkedin": "https://www.linkedin.com/in/nisha-shetty06",
            "email": "nishashetty.231ee237@nitk.edu.in"
        },
        {
            "name": "Dheemanth J",
            "photo": "Dheemanth J.jpeg",
            "linkedin": "https://www.linkedin.com/in/dheemanth-j-9967462a1",
            "email": "dheemanthj.231ec215@nitk.edu.in"
        },
        {
            "name": "Varshini Reddy Pateel",
            "photo": "Varshini Reddy Pateel.jpeg",
            "linkedin": "https://www.linkedin.com/in/varshini-reddy-pateel-311460290/",
            "email": "varshini.pateel@gmail.com"
        },
        {
            "name": "N Gopala Krishna",
            "photo": "N Gopala Krishna.jpeg",
            "linkedin": "https://www.linkedin.com/in/n-gopala-krishna-qaz4695",
            "email": "n.gopalakrishna4695@gmail.com"
        },
        {
            "name": "K Balasankar Menon",
            "photo": "Balasankar.webp",
            "linkedin": "https://www.linkedin.com/in/k-balasankar-menon-54826a321",
            "email": "kbalasankarmenon.241ec222@nitk.edu.in"
        },
        {
            "name": "Vemula Puneeth",
            "photo": "Vemula Puneeth.jpg",
            "linkedin": "https://www.linkedin.com/in/vemula-puneeth-0bbb73385",
            "email": "vemulapuneeth.241ee263@nitk.edu.in"
        },
        {
            "name": "Tarun P",
            "photo": "Tarun.jpg",
            "linkedin": "https://linkedin.com/in/tarun-p-b488a7337",
            "email": "tarun.241cs160@nitk.edu.in"
        },
        {
            "name": "Dhruva S",
            "photo": "Dhruva S.jpg",
            "linkedin": "https://www.linkedin.com/in/dhruva-s-195046277",
            "email": "dhruva.241me120@nitk.edu.in"
        },
        {
            "name": "Yash Desai",
            "photo": "Yash Desai.jpg",
            "linkedin": "https://linkedin.com/in/yash-desai-38a7bb36a",
            "email": "yashdesai.241me320@nitk.edu.in"
        },
        {
            "name": "Omkar kharade",
            "photo": "Omkar kharade.jpg",
            "linkedin": "https://www.linkedin.com/in/omkar-kharade-53a05232b",
            "email": "omkarkharade.241me140@nitk.edu.in"
        },
        {
            "name": "Mohammed Kamran",
            "photo": "Mohammed Kamran.jpg",
            "linkedin": "https://www.linkedin.com/in/mohammed-kamran-000714393/",
            "email": "mohammedkamran.251mn035@nitk.edu.in"
        },
        {
            "name": "Dhanvi Shetty",
            "photo": "Dhanvi Shetty.jpg",
            "linkedin": "https://www.linkedin.com",
            "email": "dhanvishetty.251me119@nitk.edu.in"
        },
        {
            "name": "Yuvaraj S",
            "photo": "empty photo.jpg",
            "linkedin": "https://www.linkedin.com",
            "email": "yuvarajs.251ai050@nitk.edu.in"
        }
    ],
    "Faculty Advisors": [
        {
            "name": "Dr Pruthviraj U",
            "designation": "Associated Faculty, CSD",
            "photo": "Pruthviraj.png"
        },
        {
            "name": "Dr Gangadharan K V",
            "designation": "Associated Faculty, CSD",
            "photo": "Gangadharan.png"
        }
    ]
}
